/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeSubscriptionPlan200Response } from '../models';
// @ts-ignore
import type { CheckSubscriptionStatus200Response } from '../models';
// @ts-ignore
import type { CreateSubscriptionSession200Response } from '../models';
// @ts-ignore
import type { CreateSubscriptionSessionRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { HandleWebhook200Response } from '../models';
// @ts-ignore
import type { HandleWebhookRequest } from '../models';
// @ts-ignore
import type { InitSession200Response } from '../models';
// @ts-ignore
import type { InitiateSubscriptionRequest } from '../models';
// @ts-ignore
import type { PlanChangeOptionsResponse } from '../models';
// @ts-ignore
import type { PlanChangeRequest } from '../models';
// @ts-ignore
import type { SubscriptionInfoResponse } from '../models';
// @ts-ignore
import type { SubscriptionListResponse } from '../models';
// @ts-ignore
import type { SubscriptionResponse } from '../models';
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 현재 구독의 플랜을 변경
         * @summary 구독 플랜 변경
         * @param {string} subscriptionId 구독 ID
         * @param {PlanChangeRequest} planChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionPlan: async (subscriptionId: string, planChangeRequest: PlanChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('changeSubscriptionPlan', 'subscriptionId', subscriptionId)
            // verify required parameter 'planChangeRequest' is not null or undefined
            assertParamExists('changeSubscriptionPlan', 'planChangeRequest', planChangeRequest)
            const localVarPath = `/api/v1/subscriptions/{subscriptionId}/plan-change`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 사용자의 구독 상태를 확인합니다
         * @summary 구독 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 새로운 구독 세션을 생성합니다
         * @summary 구독 세션 생성
         * @param {CreateSubscriptionSessionRequest} createSubscriptionSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionSession: async (createSubscriptionSessionRequest: CreateSubscriptionSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSubscriptionSessionRequest' is not null or undefined
            assertParamExists('createSubscriptionSession', 'createSubscriptionSessionRequest', createSubscriptionSessionRequest)
            const localVarPath = `/api/v1/subscriptions/session/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSubscriptionSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
         * @summary 플랜 변경 옵션 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanChangeOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/plan-change/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 특정 주문에 연결된 구독 정보를 조회합니다.
         * @summary 주문별 구독 정보 조회
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionByOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSubscriptionByOrder', 'orderId', orderId)
            const localVarPath = `/api/v1/subscriptions/by-order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
         * @summary 사용자 구독 목록 조회
         * @param {GetUserSubscriptionsStatusEnum} [status] 구독 상태 필터 (선택사항)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscriptions: async (status?: GetUserSubscriptionsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
         * @summary NicePay 웹훅 처리
         * @param {HandleWebhookRequest} handleWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook: async (handleWebhookRequest: HandleWebhookRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'handleWebhookRequest' is not null or undefined
            assertParamExists('handleWebhook', 'handleWebhookRequest', handleWebhookRequest)
            const localVarPath = `/api/v1/subscriptions/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(handleWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 구독 세션을 초기화합니다
         * @summary 세션 초기화
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSubscriptionSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions/session/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 새로운 구독을 초기화합니다
         * @summary 구독 초기화
         * @param {InitiateSubscriptionRequest} initiateSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSubscription: async (initiateSubscriptionRequest: InitiateSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateSubscriptionRequest' is not null or undefined
            assertParamExists('initiateSubscription', 'initiateSubscriptionRequest', initiateSubscriptionRequest)
            const localVarPath = `/api/v1/subscriptions/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 현재 구독의 플랜을 변경
         * @summary 구독 플랜 변경
         * @param {string} subscriptionId 구독 ID
         * @param {PlanChangeRequest} planChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSubscriptionPlan(subscriptionId: string, planChangeRequest: PlanChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeSubscriptionPlan200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSubscriptionPlan(subscriptionId, planChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.changeSubscriptionPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 사용자의 구독 상태를 확인합니다
         * @summary 구독 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSubscriptionStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckSubscriptionStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSubscriptionStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.checkSubscriptionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 새로운 구독 세션을 생성합니다
         * @summary 구독 세션 생성
         * @param {CreateSubscriptionSessionRequest} createSubscriptionSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubscriptionSession(createSubscriptionSessionRequest: CreateSubscriptionSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSubscriptionSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubscriptionSession(createSubscriptionSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.createSubscriptionSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
         * @summary 플랜 변경 옵션 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanChangeOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanChangeOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanChangeOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getPlanChangeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 특정 주문에 연결된 구독 정보를 조회합니다.
         * @summary 주문별 구독 정보 조회
         * @param {string} orderId 주문 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionByOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionByOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getSubscriptionByOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
         * @summary 사용자 구독 목록 조회
         * @param {GetUserSubscriptionsStatusEnum} [status] 구독 상태 필터 (선택사항)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSubscriptions(status?: GetUserSubscriptionsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSubscriptions(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.getUserSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
         * @summary NicePay 웹훅 처리
         * @param {HandleWebhookRequest} handleWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhook(handleWebhookRequest: HandleWebhookRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandleWebhook200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhook(handleWebhookRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.handleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 구독 세션을 초기화합니다
         * @summary 세션 초기화
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initSubscriptionSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initSubscriptionSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.initSubscriptionSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 새로운 구독을 초기화합니다
         * @summary 구독 초기화
         * @param {InitiateSubscriptionRequest} initiateSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateSubscription(initiateSubscriptionRequest: InitiateSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateSubscription(initiateSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionApi.initiateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * 현재 구독의 플랜을 변경
         * @summary 구독 플랜 변경
         * @param {SubscriptionApiChangeSubscriptionPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionPlan(requestParameters: SubscriptionApiChangeSubscriptionPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeSubscriptionPlan200Response> {
            return localVarFp.changeSubscriptionPlan(requestParameters.subscriptionId, requestParameters.planChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 사용자의 구독 상태를 확인합니다
         * @summary 구독 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSubscriptionStatus(options?: RawAxiosRequestConfig): AxiosPromise<CheckSubscriptionStatus200Response> {
            return localVarFp.checkSubscriptionStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 새로운 구독 세션을 생성합니다
         * @summary 구독 세션 생성
         * @param {SubscriptionApiCreateSubscriptionSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscriptionSession(requestParameters: SubscriptionApiCreateSubscriptionSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSubscriptionSession200Response> {
            return localVarFp.createSubscriptionSession(requestParameters.createSubscriptionSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
         * @summary 플랜 변경 옵션 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanChangeOptions(options?: RawAxiosRequestConfig): AxiosPromise<PlanChangeOptionsResponse> {
            return localVarFp.getPlanChangeOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 특정 주문에 연결된 구독 정보를 조회합니다.
         * @summary 주문별 구독 정보 조회
         * @param {SubscriptionApiGetSubscriptionByOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionByOrder(requestParameters: SubscriptionApiGetSubscriptionByOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfoResponse> {
            return localVarFp.getSubscriptionByOrder(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
         * @summary 사용자 구독 목록 조회
         * @param {SubscriptionApiGetUserSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSubscriptions(requestParameters: SubscriptionApiGetUserSubscriptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionListResponse> {
            return localVarFp.getUserSubscriptions(requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
         * @summary NicePay 웹훅 처리
         * @param {SubscriptionApiHandleWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhook(requestParameters: SubscriptionApiHandleWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<HandleWebhook200Response> {
            return localVarFp.handleWebhook(requestParameters.handleWebhookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 구독 세션을 초기화합니다
         * @summary 세션 초기화
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initSubscriptionSession(options?: RawAxiosRequestConfig): AxiosPromise<InitSession200Response> {
            return localVarFp.initSubscriptionSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 새로운 구독을 초기화합니다
         * @summary 구독 초기화
         * @param {SubscriptionApiInitiateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSubscription(requestParameters: SubscriptionApiInitiateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.initiateSubscription(requestParameters.initiateSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionApi - interface
 * @export
 * @interface SubscriptionApi
 */
export interface SubscriptionApiInterface {
    /**
     * 현재 구독의 플랜을 변경
     * @summary 구독 플랜 변경
     * @param {SubscriptionApiChangeSubscriptionPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    changeSubscriptionPlan(requestParameters: SubscriptionApiChangeSubscriptionPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeSubscriptionPlan200Response>;

    /**
     * 현재 사용자의 구독 상태를 확인합니다
     * @summary 구독 상태 확인
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    checkSubscriptionStatus(options?: RawAxiosRequestConfig): AxiosPromise<CheckSubscriptionStatus200Response>;

    /**
     * 새로운 구독 세션을 생성합니다
     * @summary 구독 세션 생성
     * @param {SubscriptionApiCreateSubscriptionSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    createSubscriptionSession(requestParameters: SubscriptionApiCreateSubscriptionSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSubscriptionSession200Response>;

    /**
     * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
     * @summary 플랜 변경 옵션 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    getPlanChangeOptions(options?: RawAxiosRequestConfig): AxiosPromise<PlanChangeOptionsResponse>;

    /**
     * 특정 주문에 연결된 구독 정보를 조회합니다.
     * @summary 주문별 구독 정보 조회
     * @param {SubscriptionApiGetSubscriptionByOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    getSubscriptionByOrder(requestParameters: SubscriptionApiGetSubscriptionByOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionInfoResponse>;

    /**
     * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
     * @summary 사용자 구독 목록 조회
     * @param {SubscriptionApiGetUserSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    getUserSubscriptions(requestParameters?: SubscriptionApiGetUserSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionListResponse>;

    /**
     * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
     * @summary NicePay 웹훅 처리
     * @param {SubscriptionApiHandleWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    handleWebhook(requestParameters: SubscriptionApiHandleWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<HandleWebhook200Response>;

    /**
     * 구독 세션을 초기화합니다
     * @summary 세션 초기화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    initSubscriptionSession(options?: RawAxiosRequestConfig): AxiosPromise<InitSession200Response>;

    /**
     * 새로운 구독을 초기화합니다
     * @summary 구독 초기화
     * @param {SubscriptionApiInitiateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    initiateSubscription(requestParameters: SubscriptionApiInitiateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse>;

}

/**
 * Request parameters for changeSubscriptionPlan operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiChangeSubscriptionPlanRequest
 */
export interface SubscriptionApiChangeSubscriptionPlanRequest {
    /**
     * 구독 ID
     * @type {string}
     * @memberof SubscriptionApiChangeSubscriptionPlan
     */
    readonly subscriptionId: string

    /**
     * 
     * @type {PlanChangeRequest}
     * @memberof SubscriptionApiChangeSubscriptionPlan
     */
    readonly planChangeRequest: PlanChangeRequest
}

/**
 * Request parameters for createSubscriptionSession operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiCreateSubscriptionSessionRequest
 */
export interface SubscriptionApiCreateSubscriptionSessionRequest {
    /**
     * 
     * @type {CreateSubscriptionSessionRequest}
     * @memberof SubscriptionApiCreateSubscriptionSession
     */
    readonly createSubscriptionSessionRequest: CreateSubscriptionSessionRequest
}

/**
 * Request parameters for getSubscriptionByOrder operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetSubscriptionByOrderRequest
 */
export interface SubscriptionApiGetSubscriptionByOrderRequest {
    /**
     * 주문 ID
     * @type {string}
     * @memberof SubscriptionApiGetSubscriptionByOrder
     */
    readonly orderId: string
}

/**
 * Request parameters for getUserSubscriptions operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetUserSubscriptionsRequest
 */
export interface SubscriptionApiGetUserSubscriptionsRequest {
    /**
     * 구독 상태 필터 (선택사항)
     * @type {'PENDING' | 'ACTIVE' | 'CANCELLED' | 'EXPIRED'}
     * @memberof SubscriptionApiGetUserSubscriptions
     */
    readonly status?: GetUserSubscriptionsStatusEnum
}

/**
 * Request parameters for handleWebhook operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiHandleWebhookRequest
 */
export interface SubscriptionApiHandleWebhookRequest {
    /**
     * 
     * @type {HandleWebhookRequest}
     * @memberof SubscriptionApiHandleWebhook
     */
    readonly handleWebhookRequest: HandleWebhookRequest
}

/**
 * Request parameters for initiateSubscription operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiInitiateSubscriptionRequest
 */
export interface SubscriptionApiInitiateSubscriptionRequest {
    /**
     * 
     * @type {InitiateSubscriptionRequest}
     * @memberof SubscriptionApiInitiateSubscription
     */
    readonly initiateSubscriptionRequest: InitiateSubscriptionRequest
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI implements SubscriptionApiInterface {
    /**
     * 현재 구독의 플랜을 변경
     * @summary 구독 플랜 변경
     * @param {SubscriptionApiChangeSubscriptionPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public changeSubscriptionPlan(requestParameters: SubscriptionApiChangeSubscriptionPlanRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).changeSubscriptionPlan(requestParameters.subscriptionId, requestParameters.planChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 사용자의 구독 상태를 확인합니다
     * @summary 구독 상태 확인
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public checkSubscriptionStatus(options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).checkSubscriptionStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 새로운 구독 세션을 생성합니다
     * @summary 구독 세션 생성
     * @param {SubscriptionApiCreateSubscriptionSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public createSubscriptionSession(requestParameters: SubscriptionApiCreateSubscriptionSessionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).createSubscriptionSession(requestParameters.createSubscriptionSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
     * @summary 플랜 변경 옵션 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getPlanChangeOptions(options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getPlanChangeOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 특정 주문에 연결된 구독 정보를 조회합니다.
     * @summary 주문별 구독 정보 조회
     * @param {SubscriptionApiGetSubscriptionByOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getSubscriptionByOrder(requestParameters: SubscriptionApiGetSubscriptionByOrderRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getSubscriptionByOrder(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
     * @summary 사용자 구독 목록 조회
     * @param {SubscriptionApiGetUserSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getUserSubscriptions(requestParameters: SubscriptionApiGetUserSubscriptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getUserSubscriptions(requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
     * @summary NicePay 웹훅 처리
     * @param {SubscriptionApiHandleWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public handleWebhook(requestParameters: SubscriptionApiHandleWebhookRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).handleWebhook(requestParameters.handleWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 구독 세션을 초기화합니다
     * @summary 세션 초기화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public initSubscriptionSession(options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).initSubscriptionSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 새로운 구독을 초기화합니다
     * @summary 구독 초기화
     * @param {SubscriptionApiInitiateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public initiateSubscription(requestParameters: SubscriptionApiInitiateSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).initiateSubscription(requestParameters.initiateSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetUserSubscriptionsStatusEnum = {
    Pending: 'PENDING',
    Active: 'ACTIVE',
    Cancelled: 'CANCELLED',
    Expired: 'EXPIRED'
} as const;
export type GetUserSubscriptionsStatusEnum = typeof GetUserSubscriptionsStatusEnum[keyof typeof GetUserSubscriptionsStatusEnum];
